import { action } from 'mobx';
import { observer } from 'mobx-react';
import React from 'react';
import { toast, ToastContainer } from 'react-toastify';

import { WithDbId } from '../../../../../adl-gen/common/db';
import { Competency } from '../../../../../adl-gen/totalinteraction/futurefit/db';
import { CompetencyStore } from '../../../../stores';
import { FormMode, toastOptions } from '../../../common/form';

// tslint:disable-next-line: no-import-side-effect ordered-imports
import '../../../widgets/toast/toastify.css';
import { CompetencyEditor } from '../../editors/competency-editor/competency-editor';

interface CompetencyFormProps {
  item?: WithDbId<Competency>;
  // toDelete?: WithDbId<AppClient>[];
  // clientData: ClientData;
  store: CompetencyStore;
  // onLoadClientRepository?(repos: RepositoryEntrySet, clientDomainName: string): Promise<RepositoryEntrySet>;
  // uploadRepositoryEntry(req: RepositoryPutReq): Promise<Entry>;
  // onCreate(item: AppClient): Promise<Auth0Client>;
  // onUpdate(item: WithDbId<AppClient>): Promise<Auth0Client>;
  // onDelete(a: DbKey<AppClient>[]): Promise<void>;
  // /// TODO: retire this
  // /** @deprecated Stop using modals */
  // selectMode: SelectMode;
  mode?: FormMode;
  onCancel(): void;
  /** TODO: @deprecated */
  isOpen: boolean;
}

@observer
export class CompetencyForm extends React.Component<CompetencyFormProps> {
  onCreate = async (item: Competency): Promise<void> => {
    if (!this.props.store.isSuperUser) {
      throw new Error('cannot create competency - not authorized');
    } else {
      const toastId = toast.loading('Please wait...', { ...toastOptions, autoClose: 3000 });
      try {
        // No auto-refresh
        // TODO: obsolete
        await this.props.store.create(item, true);

        toast.dismiss(toastId);
        toast.success(`Competency ${item.name.value.en} created.`, {
          ...toastOptions,
          onClose: this.props.onCancel,
          autoClose: 3000
        });
      } catch (e) {
        toast.dismiss(toastId);
        toast.error(`Competency ${item.name.value.en} create failed: ${(e as Error).message}`, {
          ...toastOptions,
          onClose: this.props.onCancel
        });
      }
    }
  };

  onUpdate = async (item: WithDbId<Competency>): Promise<void> => {
    const toastId = toast.loading('Please wait...', { ...toastOptions, autoClose: 3000 });
    try {
      /// TODO: Defer refresh to ensure confirmation dialog pops up OBSOLETE
      await this.props.store.update(item, true);

      toast.dismiss(toastId);
      toast.success(`Competency ${item.value.name.value.en} updated.`, {
        ...toastOptions,
        onClose: this.props.onCancel,
        autoClose: 3000
      });
    } catch (e) {
      toast.dismiss(toastId);
      toast.error(`Competency ${item.value.name.value.en} update failed: ${(e as Error).message}`, {
        ...toastOptions,
        onClose: this.props.onCancel
      });
    }
  };

  // onDeletes = async (a: DbKey<AppClient>[]) => {
  //   try {
  //     await this.props.onDelete(a);
  //     runInAction(() => (this.fieldState.deletedClients = a.slice()));
  //   } catch (e) {
  //     runInAction(() => (this.fieldState.error = e as Error));
  //   }
  // };

  @action
  onCancel = () => {
    this.props.onCancel();
  };

  renderContent = () => {
    const {
      item: competency,
      mode,
      store
      // toDelete,
    } = this.props;
    if (mode === 'update' && competency) {
      return (
        <CompetencyEditor
          item={competency}
          onCancel={this.onCancel}
          onCreate={this.onCreate}
          onUpdate={this.onUpdate}
          role={store.isSuperUser ? 'super' : 'client-admin'}
        />
      );
      /// TODO Delete
    } else {
      return (
        <CompetencyEditor
          onCancel={this.onCancel}
          onCreate={this.onCreate}
          role={store.isSuperUser ? 'super' : 'client-admin'}
        />
      );
    }
  };

  render() {
    return (
      <React.Fragment>
        {this.renderContent()}
        <ToastContainer newestOnTop />
      </React.Fragment>
    );
  }
}



// WEBPACK FOOTER //
// ./src/admin/ui/components/forms/competency-form/competency-form.tsx